"use client";

/**
 * NewForm design-system Textarea.
 *
 * Plain `<textarea>` with DS tokens — Rethink Sans 14px / 1.5 leading,
 * `rounded-nf-ds-inset`, brand-purple focus ring. Mirrors the legacy
 * shadcn Textarea surface for incremental swap-in:
 *
 *   import { Textarea } from "@/components/ui/design-system/textarea";
 *
 *   <Textarea rows={6} value={value} onChange={(e) => setValue(e.target.value)} />
 */

import * as React from "react";

import { cn } from "@/lib/utils";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(
          "flex w-full min-h-[80px] rounded-nf-ds-inset border border-input bg-background px-nf-ds-3 py-nf-ds-2 font-nf-ds-sans text-nf-ds-md md:text-nf-ds-base leading-[1.5] text-foreground placeholder:text-muted-foreground transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-nf-ds-purple-product/40 focus-visible:ring-offset-1 focus-visible:border-nf-ds-purple-product/60 disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        {...props}
      />
    );
  },
);
Textarea.displayName = "Textarea";

export { Textarea };
